export default async ()=> {
    const res = await fetch('/sectionData/city.json')
    const data = await res.json()
    return data
}